export default "__VITE_ASSET__BSN49K8N__"